const openGetMoreTokensModal = () => {
	window.location.hash = "getmoretokens"
}

export default openGetMoreTokensModal
